const isValidToken = (token: string) => token.split('.').length === 3;

interface Params {
  token: string;
  /** 만료까지 이 시간(초) 이내면 임박으로 판정한다. */
  bufferSeconds: number;
  runtime?: 'node' | 'web';
}

/**
 * access token이 만료 임박(또는 이미 만료)인지 판정한다.
 *
 * 토큰을 디코드할 수 없거나 `exp` 클레임이 없으면 `true`(임박)를 반환한다 —
 * 판정 불가 시 호출부가 안전하게 재발급하도록 두기 위함이다.
 */
export default function isAccessTokenExpiringSoon({
  token,
  bufferSeconds,
  runtime = typeof window === 'undefined' ? 'node' : 'web', // edge runtime 대응
}: Params): boolean {
  if (!isValidToken(token)) return true;

  const [, payloadPart] = token.split('.');

  try {
    // JWT payload는 Base64URL(-, _, padding 생략)이다. atob()는 표준 Base64만 허용하므로
    // web 경로에서는 정규화 후 디코드해야 DOMException이 나지 않는다.
    const base64DecodedPart =
      runtime === 'node'
        ? Buffer.from(payloadPart, 'base64').toString()
        : atob(payloadPart.replace(/-/g, '+').replace(/_/g, '/'));

    const exp = JSON.parse(base64DecodedPart)?.exp as number | undefined;
    if (typeof exp !== 'number') return true;

    const nowSeconds = Date.now() / 1000;
    return exp - nowSeconds <= bufferSeconds;
  } catch (error) {
    return true;
  }
}
